module.exports = __webpack_public_path__ + "img/jujialei-1.cc56d566.png";